import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$company/unternehmen/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$company/unternehmen/belege",
      params: { company: params.company },
      replace: true,
    });
  },
});
